import { PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";

import { useUsers } from "~/hooks";
import { useAuthStore } from "~/stores";
import { useResolveRedirection } from "~/utils";

export const Guest = ({ children }: PropsWithChildren) => {
  const { getCurrentUser } = useUsers();
  const accessToken = useAuthStore((state) => state.accessToken);

  const { data: currentUser } = getCurrentUser(!!accessToken);

  useResolveRedirection(currentUser);

  return children ? <>{children}</> : <Outlet />;
};
